import { render } from "./Pager.vue?vue&type=template&id=24724243&scoped=true"
import script from "./Pager.vue?vue&type=script&setup=true&lang=js"
export * from "./Pager.vue?vue&type=script&setup=true&lang=js"

import "./Pager.vue?vue&type=style&index=0&id=24724243&scoped=true&lang=scss"
import "./Pager.vue?vue&type=style&index=1&id=24724243&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24724243"],['__file',"src/components/Pager.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "24724243"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('24724243', __exports__)) {
    api.reload('24724243', __exports__)
  }
  
  module.hot.accept("./Pager.vue?vue&type=template&id=24724243&scoped=true", () => {
    api.rerender('24724243', render)
  })

}


export default __exports__